import { settingConstants } from "./constants/settingConstant";

const settingGetList = () => {
	return {
		type: settingConstants.Setting_Get_Request,
	};
};

const updateSettingContent = (data: any) => {
	return {
		type: settingConstants.SettingContentUpdateRequest,
		input: data
	};
};

const updateSettingStatus = (id: any) => {
	return {
		type: settingConstants.SettingStatusUpdateRequest,
		input: id
	};
};

const getSettingContent = (id: any) => {
	return {
		type: settingConstants.GetSettingContentRequest,
		input: id
	};
};

export const settingAction = {
	settingGetList,
	updateSettingStatus,
	updateSettingContent,
	getSettingContent
};